import React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  StaticContext,
} from "react-router";
import { PageNotFound } from "../layout";

type Props = {
  from: string;
  to: string;
  wildcardOpt?: {
    defaultTo404Page?: boolean;
    Component?:
      | React.ComponentType<any>
      | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>;
  };
};

export function RedirectRoute(props: Props): JSX.Element {
  return (
    <>
      <Route
        exact
        path={props.from}
        component={() => <Redirect to={props.to} />}
      />
      {props.wildcardOpt ? (
        props.wildcardOpt.defaultTo404Page ? (
          <Route path="**" component={PageNotFound} />
        ) : (
          <Route
            path="**"
            component={props.wildcardOpt.Component ?? PageNotFound}
          />
        )
      ) : null}
    </>
  );
}
